import { client } from 'repositories/client';
import { paths } from 'repositories/invitation/paths';
import { DetailResponse } from 'repositories/invitation/responseType';
import { getRequestPath } from 'utils/string';

const detail = async (token: string): Promise<DetailResponse> => {
  const response = await client.get<DetailResponse>(
    getRequestPath(paths.detail, { token })
  );
  return response.data;
};

export const invitation = {
  detail,
};
